export default "__VITE_PUBLIC_ASSET__e8c23b5b__"